


































import { biHT } from '@/business/bi';
import { BottomTabType, getBottomTabText, HeaderTabType, isBottomTabPage, resolveDefaultHeaderTab } from '@/config/page-tab';
import { FitWxPhonex } from '@tencent/wphk-ui';
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { Route } from 'vue-router';
import { ERouteName } from '@/config';

type CountInfo = {
  [HeaderTabType.couponlist]: number | undefined;
  [HeaderTabType.displaycouponlist]: number | undefined;
};

@Component({
	  components: {
	    FitWxPhonex,
	  },
 	})
export default class BottomTab extends Vue {
  @Prop() private isShowBottomRedDot!: boolean;
  @Prop() private countInfo!: CountInfo;
  private activeTab = BottomTabType.couponlist;
  private isShow = false;
  private bottomTabTextConfig = getBottomTabText();
  /** tab访问记录 */
  private tabVisitedMap = {};

  @Watch('$route', { immediate: true })
  private handleRouteChange(to: Route) {
  }

  private getActiveTab(route) {
    const curOriginRoute = route.name;
    switch (curOriginRoute) {
      case (BottomTabType.homeNewest):
      case (BottomTabType.home):
        return BottomTabType.home;
      case (BottomTabType.weCoupons):
        return BottomTabType.weCoupons;
      case ERouteName.weCouponsList:
        return BottomTabType.weCoupons;
      case ERouteName.weCouponsSpList:
        return BottomTabType.weCoupons;
      case ('weCouponsRedirect'): // TODO: 这个似乎用不着了
        return BottomTabType.weCoupons;
      default:
        return BottomTabType.couponlist;
    }
  }

  private onClickTab(key) {
    this.markTabVisited(key);
    // Bottom更新卡券小红点
    this.$emit('clearRedDot', { tab: 'bottom', key });
    if (key !== this.activeTab) {
      biHT('promozone.home.tabbar.click', {
        ftabkey: key,
      });
      if (key === 'weCoupons') {
        this.$router.push({
          path: '/weCoupons/couponList/class0',
        });
        return;
      }
      if (key === BottomTabType.couponlist) {
        // 「我的礼遇」按 §2.5 用已请求的两类券数量预判默认 Tab，直接落到正确 Tab，
        // 避免落地自动扣减券后再被 replace 切走造成的闪烁。
        this.$router.replace({
          name: resolveDefaultHeaderTab(
            this.countInfo?.[HeaderTabType.couponlist],
            this.countInfo?.[HeaderTabType.displaycouponlist],
          ),
        });
        return;
      }
      // 如果这次tab和上次tab不一样，才replace
      this.$router.replace({ name: key });
    }
  }

  private showNavBar(to: Route) {
    this.isShow = isBottomTabPage(to);
  }

  private isShowRedDot(key) {
    // 是否展示小红点
    // tab为我的礼遇 且 没有访问过此tab 且 需要展示红点时
    return key === BottomTabType.couponlist && !this.isTabVisited(key) && this.isShowBottomRedDot;
  }
  /**
   * 标记是否访问过此tab
   */
  private markTabVisited(tabKey) {
    const isTab = this.bottomTabTextConfig.map(item => item.key).includes(tabKey);
    if (isTab) {
      this.tabVisitedMap[tabKey] = true;
    }
  }
  /**
   * 判断是否访问过此tab
   */
  private isTabVisited(tabKey) {
    return this.tabVisitedMap[tabKey];
  }
}
